"use client";

import { useEffect, useRef } from "react";
import { trackExitIntent } from "@/lib/analytics";

export default function ExitIntentTracker() {
  const firedRef = useRef(false);

  useEffect(() => {
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0 && !firedRef.current) {
        firedRef.current = true;
        trackExitIntent();
      }
    };

    document.addEventListener("mouseleave", handleMouseLeave);
    return () => document.removeEventListener("mouseleave", handleMouseLeave);
  }, []);

  return null;
}
